module.exports = __webpack_public_path__ + "static/media/saas1.f586f6a5.jpg";